import { gsap } from "gsap";
import { Container } from "pixi.js";

import { AbstractSpine } from "../graphics/AbstractSpine";

export class AbstractScatterAnticipation extends Container {
    protected mainSpine: AbstractSpine;
    protected mainSpineAnimationName: string;
    protected parentContainer: Container;
    protected duration: number;

    constructor(
        parent: Container,
        duration: number = 1,
        nearWinSpineName: string = `spine/anticipation.json`,
        animationName: string = `animation`
    ) {
        super();

        this.parentContainer = parent;

        this.duration = duration;

        this.mainSpine = new AbstractSpine(nearWinSpineName);
        this.addChild(this.mainSpine);

        this.mainSpineAnimationName = animationName;
    }

    public getShowAnimation(): gsap.core.Tween {
        this.mainSpine.alpha = 0;

        return gsap.fromTo(
            this.mainSpine,
            {
                alpha: 0,
            },
            {
                duration: 0.2,
                onStart: this.onShowAnimationStart.bind(this),
                alpha: 1,
            }
        );
    }

    protected onShowAnimationStart(): void {
        this.mainSpine.getSpineTween(this.mainSpineAnimationName, true);
        this.parentContainer.addChildAt(this, 0);
    }

    public getHideAnimation(): gsap.core.Tween {
        return gsap.to(this.mainSpine, {
            duration: 0.2,
            onStart: () => {
                this.onHideAnimationStart.bind(this);
            },
            onComplete: () => {
                this.onHideAnimationComplete.bind(this);
            },
            alpha: 0,
        });
    }

    protected onHideAnimationStart(): void {
        //stop sound or smth
    }

    protected onHideAnimationComplete(): void {
        this.mainSpine.reset();
        gsap.killTweensOf(this.mainSpine);
        this.parentContainer.removeChild(this);
    }
}
